// extracted by mini-css-extract-plugin
export var currencyInput = "_ke-1";
export var currencySymbol = "_ke-0";